export class NotProvidedError extends Error {
  constructor(itemName: string) {
    super(`${itemName} was not provided`)
  }
}
